const LoadingSpinner = () => {
    return (
        <div className="loading-overlay animacionp">
            <div className="spinner"></div>
        </div>
    );
};

export default LoadingSpinner;      